// "My AI Writes Its Own Skills After Every Chat" — EAKC self-learning short.
// Cold Compute / Neon kit. ~118s @ 30fps. Status: PARTIAL — auto-apply-with-Undo
// is shipped; auto-PROMOTION (trust-gated autonomy) is queued.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  it edits its own persona after a chat
  problem: { start: 150, duration: 420 }, //   0:05–0:19  every correction evaporates at session end
  intuition: { start: 570, duration: 360 }, // 0:19–0:31  a reviewer watches each turn for a rule
  trigger: { start: 930, duration: 480 }, //   0:31–0:47  fires after EVERY assistant turn, fire-and-forget
  code: { start: 1410, duration: 720 }, //     0:47–1:11  the per-turn proposer (background-review.ts)
  apply: { start: 2130, duration: 540 }, //    1:11–1:29  auto-apply writes a marked block; Undo strips it
  honesty: { start: 2670, duration: 450 }, //  1:29–1:44  10 auto / 2 gated · promotion still queued
  outro: { start: 3120, duration: 330 }, //    1:44–1:55
} as const;

export const TOTAL_DURATION = 3450; // 115s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
